/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.pisos': 'Pisos',
  'pisos.agregarPisos': 'Crear Pisos',
  'pisos.modificarPisos': 'Editar Pisos',
  'pisos.pisoId': 'Piso Id',
  'pisos.empresaId': 'Empresa Id',
  'pisos.descripcionPiso': 'Descripción Piso',
  'pisos.VerPisos': 'Ver Pisos',
  'pisos.RegistroDuplicado': 'Registro Duplicado',
};
